<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;")
              div {{ $t('ui.time') }}
            th(style="width: 450px;")
              div {{ $t('ui.event') }}
            th
              div {{ $t('ui.hh') }}
            th
              div {{ $t('ui.hd') }}
            th
              div {{ $t('ui.ha') }}
            th
              div {{ $t('ui.dh') }}
            th
              div {{ $t('ui.dd') }}
            th
              div {{ $t('ui.da') }}
            th
              div {{ $t('ui.ah') }}
            th
              div {{ $t('ui.ad') }}
            th
              div {{ $t('ui.aa') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.hh_blink }") {{ item.hh }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.hd_blink }") {{ item.hd }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.ha_blink }") {{ item.ha }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.dh_blink }") {{ item.dh }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.dd_blink }") {{ item.dd }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.da_blink }") {{ item.da }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.ah_blink }") {{ item.ah }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.ad_blink }") {{ item.ad }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.aa_blink }") {{ item.aa }}
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>
